<template>
  <span class="suite-management-icon" aria-hidden="true"></span>
</template>

<style scoped>
.suite-management-icon {
  display: inline-block;
  flex-shrink: 0;
  width: 3rem;
  height: 2.4rem;
  background-color: currentColor;
  mask: url("@/assets/suiteManagement/suite-navigation.svg") center / 19.5px
    21.5px no-repeat;
}
</style>
